import { cloneDeep } from "lodash";
import UserCardResult from "../UserCardResult";
import { useEffect, useMemo, useState } from "react";
import { ROWS_PER_PAGE_ON_PAGINATED_TABLE } from "lookup";
import { cn } from "utils";
import { useScrollToTopOnChange } from "hooks/useScrollToTopOnChange";

const PageButton = ({ symbol, goToPage, disabled }) => {
  return (
    <button
      className={cn("border px-2 bg-gray-50 rounded", {
        "!bg-gray-200 opacity-50": disabled,
      })}
      onClick={goToPage}
      disabled={disabled}
    >
      {symbol}
    </button>
  );
};

const PaginationButtons = ({ goToPage, currentPage, totalPages }) => {
  return (
    <div className="flex justify-end my-4 items-center w-full">
      <span className="flex w-[100px] items-center justify-center text-sm font-medium">
        Page {currentPage} of {totalPages}
      </span>
      <div className="flex gap-x-2">
        <PageButton
          symbol={"<<"}
          goToPage={() => goToPage(1)}
          disabled={currentPage === 1}
        />
        <PageButton
          symbol={"<"}
          goToPage={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
        />

        <PageButton
          symbol={">"}
          goToPage={() => {
            goToPage(currentPage + 1);
          }}
          disabled={currentPage === totalPages}
        />

        <PageButton
          symbol={">>"}
          goToPage={() => goToPage(totalPages)}
          disabled={currentPage === totalPages}
        />
      </div>
    </div>
  );
};

const PaginatedList = ({ data, onVisibleItemsChange, ...rest }) => {
  const [currentPage, setCurrentPage] = useState(1);
  useScrollToTopOnChange(currentPage);

  const itemsPerPage = ROWS_PER_PAGE_ON_PAGINATED_TABLE;

  const totalPages = Math.ceil(data.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = useMemo(
    () => data.slice(startIndex, startIndex + itemsPerPage),
    [data, itemsPerPage, startIndex]
  );

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    onVisibleItemsChange(currentItems);
  }, [currentItems, onVisibleItemsChange]);

  if (data?.length === 0) {
    return null;
  }

  return (
    <>
      <div className="flex flex-col gap-y-8">
        {currentItems.map((hit) => {
          const clonedHit = cloneDeep(hit);

          return (
            <UserCardResult key={clonedHit.id} hit={clonedHit} {...rest} />
          );
        })}
      </div>
      <PaginationButtons
        goToPage={goToPage}
        currentPage={currentPage}
        totalPages={totalPages}
      />
    </>
  );
};

export default PaginatedList;
